module.exports = __webpack_public_path__ + "img/logo.bb6a74b2.png";